"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var react_dom_1 = require("react-dom");
var click_outside_1 = require("../../hooks/click-outside");
var key_event_1 = require("../../hooks/key-event");
var portal_1 = require("../../hooks/portal");
var theme_1 = require("../../theme");
function Popover(props) {
    var onToggle = props.onToggle, isOpen = props.isOpen, _a = props.hideOnClickOutside, hideOnClickOutside = _a === void 0 ? true : _a, children = props.children, innerRef = props.innerRef, testId = props.testId;
    var container = (0, portal_1.usePortal)('popover');
    (0, key_event_1.useKeyEvent)('Escape', function () {
        if (isOpen) {
            onToggle(false);
        }
    }, [isOpen, onToggle]);
    (0, click_outside_1.useOnClickOutside)(innerRef, function () {
        if (!isOpen || !hideOnClickOutside) {
            return;
        }
        onToggle(false);
    });
    if (!container || !isOpen) {
        return null;
    }
    return (0, react_dom_1.createPortal)(react_1.default.createElement("div", { style: { zIndex: theme_1.zIndices.popover }, "data-testid": testId, ref: innerRef }, children), container);
}
exports.Popover = Popover;
//# sourceMappingURL=index.js.map